import React, { useEffect, useState, useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import AnimateOnScroll from './AnimateOnScroll';
import './EventCarousel.css';

// Importando as imagens dos eventos
import event1 from '../assets/events/event1.jpg';
import event2 from '../assets/events/event2.jpg';
import event3 from '../assets/events/event3.jpg';
import event4 from '../assets/events/event4.jpg';
import event5 from '../assets/events/event5.jpg';
import event6 from '../assets/events/event6.jpg';
import event7 from '../assets/events/event7.jpg';
import event8 from '../assets/events/event8.jpg';
import event9 from '../assets/events/event9.jpg';
import event10 from '../assets/events/event10.jpg';
import event11 from '../assets/events/event11.jpg';
import event12 from '../assets/events/event12.jpg';
import event13 from '../assets/events/event13.jpg';
import event14 from '../assets/events/event14.jpg';

const EventCarousel = () => {
  const images = [
    { src: event1, caption: 'Bientech no Evento de Pediatria' },
    { src: event2, caption: 'Banner de Apresentação Oficial' },
    { src: event3, caption: 'Divulgação da Nossa Solução' },
    { src: event4, caption: 'Reabilitação Respiratória Infantil' },
    { src: event5, caption: 'BTOne para Crianças' },
    { src: event6, caption: 'Tecnologia que Encanta' },
    { src: event7, caption: 'Inovação na Fisioterapia Infantil' },
    { src: event8, caption: 'Premiação em Congresso Internacional' },
    { src: event9, caption: 'Rodadas de Investimento ' },
    { src: event10, caption: 'Equipe Bientech em Evento' },
    { src: event11, caption: 'Conversas com Investidores' },
    { src: event12, caption: 'Início no South Summit' },
    { src: event13, caption: '1º Lugar Startup RS GO — Equipe Bientech na Premiação' },
    { src: event14, caption: 'XIII SULBRAFIR — Nossa Solução no Congresso Sul-Brasileiro de Fisioterapia Respiratória' }
  ];

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: 'center',
      skipSnaps: false,
      dragFree: false,
    },
    [Autoplay({ delay: 3000, stopOnInteraction: false })]
  );

  const [selectedIndex, setSelectedIndex] = useState(0);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on('select', onSelect);
  }, [emblaApi, onSelect]);

  return (
    <AnimateOnScroll as="section" className="event-carousel-section" variant="fadeDown">
      <div className="event-carousel-container">
        <div className="embla-events">
          <div className="embla-events__viewport" ref={emblaRef}>
            <div className="embla-events__container">
              {images.map((image, index) => (
                <div
                  className={`embla-events__slide ${index === selectedIndex ? 'is-selected' : ''}`}
                  key={index}
                >
                  <div className="embla-events__slide__inner">
                    <img src={image.src} alt={`Evento ${index + 1}`} className="embla-events__img" />
                    <div className="embla-events__caption">
                      <h3>{image.caption}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </AnimateOnScroll>
  );
};

export default EventCarousel; 